import { BodySmHTML, H5 } from '@/components/ui/typography/Typography';
import { formatViews } from '@/utils/formatViews';
import { Calendar, Eye, Folder } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function NewsCard({ item }) {
  return (
    <Link to={`/berita/${item.slug}`} className="block group cursor-pointer h-full">
      <div className="rounded-md lg:rounded-xl overflow-hidden shadow bg-white flex flex-col h-full transition-all duration-300 group-hover:shadow-md">
        {/* Thumbnail */}
        <div className="relative w-full p-2 lg:p-3">
          <img
            src={item.thumbnail}
            alt={item.slug}
            className="aspect-[16/9] w-full rounded-md xl:rounded-xl bg-gray-100 object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 rounded-md xl:rounded-xl " />
        </div>

        {/* Content */}
        <div className="px-2 lg:px-3 pb-2 lg:pb-4 flex flex-col flex-grow gap-2">
          {/* Title */}
          <H5 className="line-clamp-2 hover:text-accent-600">{item.title}</H5>

          {/* Description */}
          <BodySmHTML content={item.content} className="text-gray-600 line-clamp-2 leading-snug" />
          <hr className="border-gray-200 mt-2" />
          {/* Meta */}
          <div className="flex items-center flex-wrap gap-1">
            <div className="flex items-center gap-1 bg-gray-100 px-3 py-0.5 rounded-md text-gray-700 text-[10px]">
              <Folder size={12} lg:size={14} />
              <span>{item.category}</span>
            </div>

            <div className="flex items-center gap-1 bg-gray-100 px-3 py-0.5 rounded-md text-gray-700 text-[10px]">
              <Calendar size={12} lg:size={14} />
              <span>{item.date}</span>
            </div>

            <div className="flex items-center gap-1 bg-gray-100 px-3 py-0.5 rounded-md text-gray-700 text-[10px]">
              <Eye size={12} lg:size={14} />
              <span>{formatViews(item.views)}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
